const ja = {
    '/': {
        title: '{brand} | スポーツベッティング、ライブカジノ & 即時出金',
        description: '{brand}でスロット、ライブカジノを楽しみ、スポーツに賭けましょう。即時出金、証明可能なフェアゲーム & 24時間サポートのクリプトカジノ。'
    },
    '/casino': {
        title: 'オンラインカジノ | スロット、ブラックジャック & ライブディーラー | {brand}',
        description: '{brand}でスロット、ブラックジャック、ルーレット & ライブディーラーを楽しめます。数百のゲーム、高速クリプト入金 & 24時間いつでも即時出金。'
    },
    '/sports': {
        title: 'オンラインスポーツベッティング | クリプトスポーツベット & オッズ | {brand}',
        description: '{brand}でスポーツに賭けましょう。サッカー、バスケットボールなどの競争力あるオッズ。ライブベッティング、安全なクリプト賭け & 迅速な支払い。'
    },
    '/livecasino': {
        title: 'ライブカジノ | ブラックジャック、ルーレット & ライブディーラー | {brand}',
        description: '{brand}でブラックジャック、ルーレット & ライブカジノゲームを楽しめます。本物のディーラー、HDストリーミング & 24時間豊富なライブテーブル。'
    },
    '/slots': {
        title: 'オンラインスロット | 豊富なカジノスロット | {brand}',
        description: '{brand}で膨大なスロットコレクションを回しましょう。クラシックフルーツマシン、ビデオスロット & プログレッシブ – すべてクリプトでプレイ可能。'
    },
    '/vip': {
        title: 'VIPプログラム | 限定リワード & 特典 | {brand}',
        description: '{brand}のVIPプログラム：限定ボーナス、パーソナライズ特典、優先サポート。アクティブなプレイヤー向けの特別な恩恵。'
    },
    '/welcome-offer': {
        title: 'ウェルカムオファー | クリプトカジノ | {brand}',
        description: '{brand}のウェルカムオファーをご確認ください。クリプトで始めて、新規プレイヤー限定の特典をお楽しみください。'
    },
    '/referral': {
        title: '紹介プログラム | リワードを獲得 | {brand}',
        description: '友達を{brand}に招待して、参加・条件達成時にリワードを獲得しましょう。紹介リンクをシェアして稼ぎ始めよう。'
    },
    '/promotion-page': {
        title: 'プロモーション | ボーナス & 特別オファー | {brand}',
        description: '{brand}の全プロモーションをご覧ください。クリプトプレイヤー向けのボーナス、フリースピン、特別オファー。'
    },
    '/hotslots': {
        title: '人気スロット | 話題のカジノスロット | {brand}',
        description: '{brand}で最も人気のスロットゲームをプレイ。ホットなスロットをクリプトで楽しもう。'
    },
    '/newgames': {
        title: '新着ゲーム | 最新カジノゲーム | {brand}',
        description: '{brand}で最新のカジノゲームをチェック。スロット、ライブゲーム、テーブルゲームの新作が続々登場。'
    },
    '/populargames': {
        title: '人気ゲーム | 人気カジノゲーム | {brand}',
        description: '{brand}で最も人気の高いカジノゲームをお楽しみください。スロットからライブゲームまで幅広くご用意。'
    },
    '/gameshows': {
        title: 'ゲームショー | ライブゲームショーカジノ | {brand}',
        description: '{brand}でライブゲームショーをお楽しみください。本物の司会者とユニークなゲームで大勝ちを目指そう。'
    },
    '/table_games': {
        title: 'テーブルゲーム | ブラックジャック、ルーレット & バカラ | {brand}',
        description: '{brand}でブラックジャック、ルーレット、バカラなどのテーブルゲームをお楽しみください。クリプトでプレイ可能。'
    },
    '/hotlive': {
        title: '人気ライブカジノ | 注目のライブカジノゲーム | {brand}',
        description: '{brand}で最も人気の高いライブカジノゲームをお楽しみください。本物のディーラーとリアルタイムで対戦。'
    },
    '/featurebuyin': {
        title: 'ボーナス購入スロット | フィーチャーバイイン | {brand}',
        description: '{brand}でボーナス購入機能付きスロットをプレイ。待たずにボーナスラウンドへ直接アクセス。'
    },
    '/originals': {
        title: 'オリジナルカジノゲーム | 限定タイトル | {brand}',
        description: '{brand}で独自開発の限定オリジナルゲームをプレイ。他では遊べないユニークなタイトルで、比類なきカジノ体験をお届けします。'
    },
    '/providers': {
        title: 'ゲームプロバイダー | 提携スタジオ & ソフトウェア | {brand}',
        description: '{brand}の全ゲームプロバイダーをチェック。トップスタジオと提携し、多彩で高品質なクリプトカジノライブラリをご提供しています。'
    },
    '/about-us': {
        title: '私たちについて | {brand}をもっと知る',
        description: 'クリプトカジノ & スポーツブックのリーディングブランド{brand}について詳しく知る。安全、公正、スリリングなギャンブルと即時クリプト出金へのこだわりをご紹介。'
    },
    '/affiliate': {
        title: 'アフィリエイトプログラム | {brand}でクリプトを稼ごう',
        description: '{brand}のパートナーとなり、クリプトカジノのプロモーションで報酬を獲得。競争力のあるレート、リアルタイム追跡、専任アフィリエイトサポートをご提供。'
    },
    '/faq': {
        title: 'よくある質問 | FAQ | {brand}',
        description: '{brand}に関するよくある質問の回答を探す。アカウント、支払い、ボーナス & カジノゲームについてFAQをご参照ください。'
    },
    '/aml-policy': {
        title: 'AMLポリシー | {brand}のマネーロンダリング防止対策',
        description: '{brand}のAMLポリシーは安全で信頼性の高い環境を保証します。プラットフォーム上の不正行為防止対策についてご確認ください。'
    },
    '/bonus-terms': {
        title: 'ボーナス利用規約 | {brand}のプロモーション',
        description: '{brand}のカジノボーナス & プロモーションの規約をお読みください。ボーナスの取得、使用、ボーナス獲得額の出金方法についてご確認ください。'
    },
    '/complaints-and-arbitration': {
        title: '苦情と仲裁 | {brand}のプレイヤーサポート',
        description: '{brand}の苦情・紛争解決プロセスをご確認ください。公正な取り扱いを保証し、プレイヤーの問題を迅速かつ透明に解決します。'
    },
    '/fairness': {
        title: 'プロバブリーフェアゲーム | {brand}の公正性保証',
        description: '{brand}はプロバブリーフェア技術を使用し、すべてのゲーム結果が検証可能、透明、かつ完全にランダムであることを保証します。'
    },
    '/kyc-policy': {
        title: 'KYCポリシー | {brand}の本人確認',
        description: '{brand}のKYCポリシーでは本人確認プロセスについて説明しています。プレイヤーの保護と安全なゲーミング環境の維持方法をご確認ください。'
    },
    '/payment-policy': {
        title: '支払いポリシー | クリプト入出金 | {brand}',
        description: '{brand}はクリプトでの入出金に対応。取引限度額、利用可能なコイン、処理時間については支払いポリシーをお読みください。'
    },
    '/privacy-policy': {
        title: 'プライバシーポリシー | {brand}のデータ保護',
        description: '{brand}のプライバシーポリシー。クリプトカジノプラットフォームにおける個人データの収集、利用、保護方法についてご確認ください。'
    },
    '/responsible-gaming': {
        title: '責任あるギャンブル | {brand}で安全にプレイ',
        description: '{brand}は責任あるギャンブルへの取り組みを重視しています。プレイ習慣を管理し安全に楽しむためのツール & リソースをご利用ください。'
    },
    '/terms-of-service': {
        title: '利用規約 | {brand}',
        description: '{brand}の利用を規定する利用規約をご確認ください。プレイヤーとしての権利と責任について理解を深めてください。'
    },
    '/terms-sports': {
        title: 'スポーツベッティング利用規約 | {brand}',
        description: '{brand}のスポーツベッティング利用規約。ベットの配置、当選払い戻し & プラットフォームでのスポーツブック利用に関するルールをご確認ください。'
    }
};
export default ja;
